/** Page sizes offered by list tables (one set across the panel). */
export const PAGE_SIZE_OPTIONS = [10, 30, 50, 100];
